import React from 'react';
import { FadeIn } from './FadeIn';
export function Qualifier() {
  return <section className="py-16 sm:py-24 px-4 bg-pump-surface border-y border-pump-muted" data-id="element-190">
      <div className="max-w-3xl mx-auto text-center" data-id="element-191">
        <FadeIn data-id="element-192">
          <h2 className="text-2xl sm:text-3xl font-display font-bold text-white mb-8" data-id="element-193">
            Pero antes de decirte el precio, necesito ser directo con vos.
          </h2>

          <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-194">
            <p data-id="element-195">
              Este protocolo <strong className="text-red-400" data-id="element-196">no es</strong>{' '}
              para el instructor que quiere más material para guardar en una
              carpeta que nunca va a abrir.
            </p>
            <p data-id="element-197">
              Es para el instructor que está dispuesto a usarlo. Que va a abrir
              el Tomo 1 esta semana y va a repensar cómo usa su cuerpo y su voz
              en el escenario. Que va a implementar el script de storytelling en
              su próxima clase. Que va a quedarse 5 minutos después de la clase
              con sus alumnos.
            </p>
            <p data-id="element-198">
              Es para el instructor que entiende que dar una buena clase no
              alcanza. Que sus alumnos merecen una experiencia que los haga
              volver. Que una sala llena no es suerte. Es construcción.
            </p>
            <p className="text-white font-bold text-xl mt-8" data-id="element-199">
              Si eso sos vos, este protocolo va a cambiar la forma en que
              trabajás. <br className="hidden sm:block" data-id="element-200" />
              <span className="text-pump-gold" data-id="element-201">
                No en tres meses. Desde la primera clase.
              </span>
            </p>
            <p className="text-sm text-gray-500 mt-8 uppercase tracking-widest font-bold" data-id="element-202">
              Si no estás listo para implementarlo, no te lo vendas a vos mismo.
              No es para guardar. Es para usar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}